import { EditButtons } from '../Components/EditPage/EditButtons/EditButtons';

export default function EditPage() {

    return (
        <div className="edit">
            <h2>Choose Content to Create</h2>
           <EditButtons></EditButtons>
        </div>
    )
}